import { ouvrir } from './base.js';
import { MAGASINS } from '../sync.js';
import { construireExport, valider, deciderImport, nomFichier } from '../sauvegarde.js';

/**
 * Transport de l'export et de l'import. Ne décide de rien : `sauvegarde.js`
 * porte les règles, ce module lit, écrit et déclenche le téléchargement.
 */

async function toutesLocales() {
  const db = await ouvrir();
  const paires = [];
  for (const [type, magasin] of Object.entries(MAGASINS)) {
    for (const e of await db.getAll(magasin)) paires.push({ ...e, type });
  }
  return paires;
}

/** Déclenche le téléchargement d'un export. */
export async function exporter({ inclureSupprimes = false } = {}) {
  const db = await ouvrir();
  const doc = construireExport({
    profiles: await db.getAll('profiles'),
    quotes: await db.getAll('quotes'),
    movements: await db.getAll('movements'),
  }, { inclureSupprimes });

  const blob = new Blob([JSON.stringify(doc, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const lien = document.createElement('a');
  lien.href = url;
  lien.download = nomFichier();
  lien.click();
  // Sans révocation, le blob reste en mémoire jusqu'au rechargement de la page.
  URL.revokeObjectURL(url);

  return { profils: doc.profiles.length, devis: doc.quotes.length, mouvements: doc.movements.length };
}

/**
 * Importe un document déjà analysé.
 *
 * En mode « remplacer », le magasin est vidé avant écriture. C'est destructif
 * et assumé : l'utilisateur l'a demandé explicitement, et c'est le seul mode
 * qui permet de revenir à un état antérieur connu.
 */
export async function importer(doc, mode) {
  const erreur = valider(doc);
  if (erreur) throw new Error(erreur);

  const locales = new Map((await toutesLocales()).map((e) => [`${e.type}:${e.id}`, e]));
  const { aEcrire, ignorees } = deciderImport(doc, locales, mode);

  const db = await ouvrir();
  if (mode === 'remplacer') {
    for (const magasin of Object.values(MAGASINS)) await db.clear(magasin);
  }
  for (const e of aEcrire) {
    const { type, ...entite } = e;
    await db.put(MAGASINS[type], entite);
  }

  return { ecrits: aEcrire.length, ignores: ignorees.length };
}

/** Lit un fichier choisi par l'utilisateur et le rend analysé. */
export async function lireFichier(fichier) {
  const texte = await fichier.text();
  try {
    return JSON.parse(texte);
  } catch {
    throw new Error('Fichier illisible : ce n’est pas du JSON valide.');
  }
}
